<div class="date-filter-dropdown">
    <!-- Dropdown Trigger Button -->
    <p-dropdown 
      styleClass="dropdown-rounded"
      [autoDisplayFirst]="false"
      [placeholder]="getDisplayLabel()"
      (click)="op.toggle($event)">
    </p-dropdown>

    <!-- Overlay Panel with Date Filter -->
    <p-overlayPanel #op [showCloseIcon]="false" [dismissable]="true">
      <div class="date-filter-container p-3 flex flex-wrap">
        <div class="quick-filters mb-3">
          <button 
            type="button" 
            class=" col-4 btn-secondary"
            [class.active]="selectedFilter === 'pastDue'"
            (click)="selectFilter('pastDue');">
            Past Due
          </button>
          <button 
            type="button" 
            class=" col-4 btn-secondary"
            [class.active]="selectedFilter === 'today'"
            (click)="selectFilter('today')">
            Today
          </button>
          <button 
            type="button" 
            class=" col-4 btn-secondary white-space-nowrap"
            [class.active]="selectedFilter === 'next7Days'"
            (click)="selectFilter('next7Days')">
            Next 7 Days
          </button>
        </div>

        <div class="date-inputs">
          <div class="date-field">
            <label for="startDate">Start Date</label>
            <p-calendar appendTo="body" [selectOtherMonths]="true" 
              id="startDate"
              [(ngModel)]="pendingStartDate"
              (onSelect)="onDatePicked()"
              [showIcon]="true"
              [readonlyInput]="true"
              [iconDisplay]="'input'"
              inputId="icondisplay"
              dateFormat="mm-dd-yy"
              placeholder="MM-DD-YYYY">
            </p-calendar>
          </div>

          <div class="date-field">
            <label for="endDate">End Date</label>
            <p-calendar appendTo="body" [selectOtherMonths]="true" 
              id="endDate"
              [(ngModel)]="pendingEndDate"
              (onSelect)="onDatePicked()"
              [showIcon]="true"
              [readonlyInput]="true"
              inputId="icondisplay"
              [iconDisplay]="'input'"
              dateFormat="mm-dd-yy"
              placeholder="MM-DD-YYYY">
            </p-calendar>
          </div>
        </div>

        <div class="action-button mt-3 w-full">
          <p-button 
            styleClass="w-full"
            class="w-full"
            label="Apply"
            (click)="applyFilter(); op.hide()">
          </p-button>
        </div>

      </div>
    </p-overlayPanel>
  </div>